import { types, Instance } from 'mobx-state-tree';

import {
	getStudentFinalCertificatesStatistics,
} from '@common/api/reports';
import TableData, { ITableDataQuery } from '@common/models/TableData';

import Certificate from './Certificate';

const Certificates = types
	.compose(
		TableData,
		types.model({
			data: types.optional(types.array(Certificate), []),
			student_id: types.maybeNull(types.number),
		}),
	)
	.named('Certificates')
	.actions((self) => ({
		setLoading(value: boolean) {
			self.loading = value;
		},
		_fetch: (query: ITableDataQuery) => getStudentFinalCertificatesStatistics({
			...query,
			student_id: self.student_id,
		}),
	}));

export default Certificates;

export interface ICertificatesModel extends Instance<typeof Certificates> {}
